<template>
  <!-- 课程详情 -->
  <div
    class="course-description"
    :class="{
      'h5-course-description': isH5,
      'pc-course-description': !isH5,
      'electron-course-description': isElectron,
    }"
  >
    <div>
      <div
        class="ql-editor"
        :class="{
          'product-info-wrap': canShowAllInfo,
          'show-all': showAllStatus,
        }"
        v-html="courseDescription"
      ></div>
    </div>
    <!-- 展开/收起 -->
    <div class="show-all-info" v-if="canShowAllInfo">
      <span v-if="!showAllStatus" @click="showAllStatus = true">
        展开<i class="el-icon-arrow-down"></i
      ></span>
      <span v-else @click="showAllStatus = false">
        收起<i class="el-icon-arrow-up"></i
      ></span>
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  props: {
    isH5: {
      type: Boolean,
      default: false,
    },
    courseDescription: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      canShowAllInfo: false, //是否可展开收起
      showAllStatus: false, //false:展开，true：收起
      isElectron: window.isElectron,
    };
  },
};
</script>

<style lang="scss" scoped>
.pc-course-description {
  font-size: 13px;
  .show-all-info {
    font-size: 14px;
    text-align: center;
    padding-top: 10px;
    span {
      cursor: pointer;
    }
    i {
      margin-left: 10px;
    }
  }
}
.h5-course-description {
  .show-all-info {
    text-align: center;
    font-size: 0.37rem;
    line-height: 0.53rem;
    padding: 0.43rem 0;
    i {
      margin-left: 0.25rem;
    }
  }
}
// 公共
.product-info-wrap {
  max-height: 4000px;
  overflow: hidden;
}
.show-all {
  max-height: none;
}
::v-deep .ql-editor {
  font-size: 14px;
  line-height: 1.8;
  ol,
  ul {
    padding-left: 0;
  }
  ul li:not(.ql-direction-rtl) {
    padding-left: 1em;
  }
}
</style>
